export default __webpack_public_path__ + "57fd05d4ae650374c8deeff7c4aae380.ttf";